import { constants } from 'aliases';
import * as yup from 'yup';

export const emailSchema = yup
  .string()
  .email('Invalid email format')
  .required('Email is required')
  .matches(
    new RegExp(JSON.parse(JSON.stringify(constants.login.emailRegex))),
    'Invalid email format',
  );

export const passwordSchema = yup
  .string()
  .min(12, '12 characters minimum')
  .matches(new RegExp('[a-z]'), 'Missing lower case')
  .matches(new RegExp('[A-Z]'), 'Missing upper case')
  .matches(new RegExp('[0-9]'), 'Missing number')
  .matches(new RegExp('[\\!-/:-@\\[-\\`{-~]'), 'Missing symbol') // Excludes weird symbols such as π and others found in KeyboardLayouts.SYMBOLS.
  .matches(new RegExp('^\\S+$'), 'No spaces')
  .max(32, '32 characters maximum');
